<template>
    <div class="margin">
        <content-item-container :showWord="true" :isCenter="true" wordPosition="center">
            <div class="reward-box">
                <div class="reward-text">1.邮储新客报名即可获得数字人民币红包。</div>
                <div class="reward-text">2.邮储新客报名后，24小时内首次开通邮储银行数字人民币钱包，还可以领取额外6元数字人民币红包！</div>
                <img class="button-sign-up" @click="jionActive" src="../../../assets/images/postalNewCustomer/button_sign_up.png" alt="">
            </div>
        </content-item-container>
    </div>
</template>

<script>
import contentItemContainer from './ContentItemContainer.vue'

export default {
    components: { contentItemContainer },
    data() {
        return {}
    },
    computed: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {
        jionActive() {
            this.$emit('jionActive')
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.margin {
    margin-bottom: pxvw(20);
    .reward-box {
        padding: pxvw(76) pxvw(58) pxvw(48);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .reward-text {
            font-size: pxvw(26);
            width: pxvw(548);
            text-align: justify;
            color: #898989;
            line-height: pxvw(40);
        }
        .button-sign-up {
            width: pxvw(522);
            height: pxvw(94);
            font-size: 0;
            margin-top: pxvw(36);
        }
    }
}
</style>